import { Outlet } from "react-router-dom";
import AdminRouteLayout from "../../navigation/AdminRouteLayout";

const LeasePurposeRoot = () => {
  return (
    <AdminRouteLayout>
      <Outlet />
    </AdminRouteLayout>
  );
};

export default LeasePurposeRoot;
